import { render, staticRenderFns } from "./DemoPostCreator.vue?vue&type=template&id=f0558b52&scoped=true&"
import script from "./DemoPostCreator.vue?vue&type=script&lang=js&"
export * from "./DemoPostCreator.vue?vue&type=script&lang=js&"
import style0 from "./DemoPostCreator.vue?vue&type=style&index=0&id=f0558b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0558b52",
  null
  
)

export default component.exports